import { useTranslation } from 'react-i18next';

export default function WhyChooseUs() {
  const { t } = useTranslation();

  const stats = [
    { value: '15+', labelKey: 'why_stat1' },
    { value: '5,000+', labelKey: 'why_stat2' },
    { value: '2', labelKey: 'why_stat3' },
    { value: '100%', labelKey: 'why_stat4' },
  ];

  const reasons = [
    { icon: 'ri-medal-2-line', titleKey: 'why_r1_title', descKey: 'why_r1_desc' },
    { icon: 'ri-customer-service-2-line', titleKey: 'why_r2_title', descKey: 'why_r2_desc' },
    { icon: 'ri-tools-line', titleKey: 'why_r3_title', descKey: 'why_r3_desc' },
    { icon: 'ri-price-tag-3-line', titleKey: 'why_r4_title', descKey: 'why_r4_desc' },
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image + Stats */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/c29cfed42627b595165d7f1f0a11484f.jpg"
                alt="Happy family in modern home"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Stats overlay card */}
            <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-white rounded-2xl p-6 border border-slate-100 grid grid-cols-2 gap-x-8 gap-y-5 w-72">
              {stats.map((stat) => (
                <div key={stat.labelKey}>
                  <div className="text-2xl font-black text-sky-600">{stat.value}</div>
                  <div className="text-xs text-slate-500 font-medium mt-0.5">{t(stat.labelKey)}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('why_tag')}</span>
            <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 mb-6 leading-tight">
              {t('why_title1')}<br />{t('why_title2')}
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-10">
              {t('why_desc')}
            </p>

            <div className="space-y-7">
              {reasons.map((reason) => (
                <div key={reason.titleKey} className="flex items-start gap-5">
                  <div className="w-11 h-11 bg-sky-50 rounded-xl flex items-center justify-center shrink-0">
                    <i className={`${reason.icon} text-sky-600 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-slate-800 mb-1">{t(reason.titleKey)}</h3>
                    <p className="text-slate-500 text-sm leading-relaxed">{t(reason.descKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
